import type { FaireProductEntity } from "../../entity_types/product";

export const p_fnbua8gzu9: FaireProductEntity = {
  token: "p_fnbua8gzu9",
  type: "product",
  name: "Guava Gloss Drops",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/386a6cd486d251e6d91aa17df4f40e51ba6135d5755ff1a5ebdfc626dc6c061c.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 12,
  description: "Guava Gloss Drops for wholesale.",
  tags: ["haircare"],
  caseSize: 6,
  msrpDollars: 24,
  isBestseller: true,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
